import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=6debb0e2"
import script from "../script/menu.js?vue&type=script&lang=js&external"
export * from "../script/menu.js?vue&type=script&lang=js&external"
import style0 from "../less/menu.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports